































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import approvalList from '@/components/approval-list.vue';
import { ActionConstants } from '@/stores/approvals/action-constants';
import { Approval } from '@/models/approval';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const approvalModule = namespace('approval');
const userModule = namespace('user');

@Component({
    components: {
        layout,
        breadcrumb,
        approvalList,
    },
})
export default class Approvals extends Vue {
    public isLoading: boolean = true;
    @approvalModule.Getter('allApprovalsTotalPages') public totalPages: number;
    @approvalModule.Getter('allApprovalsPageSize') public currentPageSize: number;
    @approvalModule.Getter('allApprovalsTotal') public totalApprovals: number;
    @approvalModule.Getter('allApprovals') public approvals: Array<Approval>;
    @approvalModule.Getter('allApprovalsPage') public currentPage: number;
    @approvalModule.Getter('allApprovalsFilterStatus') public filterStatus: Array<Approval>;
    @approvalModule.Getter('allApprovalsFrom') public from: string | null;
    @approvalModule.Getter('allApprovalsTo') public to: string | null;
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    public async handlePageChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllApprovalsPage, value);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: null, to: null });

        this.isLoading = false;
    }
    public async handleStatusChanged(value: number | string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllApprovalsFilterStatus, value);
        await this.$store.dispatch(ActionConstants.updateAllApprovalsPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleFromChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllApprovalsFrom, value);
        await this.$store.dispatch(ActionConstants.updateAllApprovalsPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleToChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllApprovalsTo, value);
        await this.$store.dispatch(ActionConstants.updateAllApprovalsPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updateAllApprovalsPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
        this.isLoading = false;
    }
}
